import { Component } from '@angular/core';
import { NavController, NavParams, ToastController, AlertController, Item } from 'ionic-angular';
import { Api } from '../../providers/api';
import {FormBuilder, FormGroup, FormControl, Validators, AbstractControl} from '@angular/forms';
import { Storage } from '@ionic/storage';
import {pickPackParams, Theming} from "../../providers/data";
// import {customFields} from "../../providers/config";
import {CartPage} from '../cart/cart';
import { PickpacklistPage } from '../pickpacklist/pickpacklist';
// import { customFieldsProvider } from '../../providers/params';
import { MsgManager } from '../../providers/msg-manager';
import {GVLogger} from "../../services/gv-logger";

// $IMPORTSTATEMENT

/**
 * Generated class for the pickpackparamsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */
// $IONICPAGE
@Component({
  selector: 'page-pickpackparams',
  templateUrl: 'pickpackparams.html',
})
export class PickPackParamsPage {
	private theming = Theming;
	public cart : any;
	public encoded;
	deoded;
	pickpackform: FormGroup;
	objCustomFormFields = [];


	// customFieldss : PickpacklistPage;

	// pickPackList = customFieldsProvider.customFields;

	setProfileBadge:boolean;
	pickPackList: any;
  private paramsProvider ;
  calledFrom = "";
	constructor(private api: Api,
		public toastCtrl:ToastController,
		public nav: NavController,
		public formBuilder: FormBuilder,
		public storage: Storage,
		public params:NavParams,
    private gVLogger: GVLogger,
		private msgManager: MsgManager)
	{

		// this.pickPackList = paramsProvider.customFields;
  	this.pickpackform = new FormGroup({
		var0: new FormControl('', [Validators.required, Validators.maxLength(25)]),
		var1: new FormControl('', [Validators.required, Validators.maxLength(25)]),
		var2: new FormControl('', [Validators.required, Validators.maxLength(25)]),
		var3: new FormControl('', [Validators.required, Validators.maxLength(25)]),
		var4: new FormControl('', [Validators.required, Validators.maxLength(25)]),
		var5: new FormControl('', [Validators.required, Validators.maxLength(25)]),
		var6: new FormControl('', [Validators.required, Validators.maxLength(25)]),
		var7: new FormControl('', [Validators.required, Validators.maxLength(25)]),


		});

		this.cart = this.params.get("cart");
		this.calledFrom = this.params.get("calledFrom");
    this.getParamsFieldsFromServer();
    this.paramsField();
		// this.pickPackParamsRead();
		// this.encode();
	}

  getParamsFieldsFromServer(){
	  // this.gVLogger.log("ccccccccccceeeeeeeelllllllllldddddddddddddd");
    this.api.get("/adpCust/getIntelliStockParams")
      .map(res => res.json())
      .subscribe((results)=>{
          if(results.status === "200"){
            // this.gVLogger.log("ccccccccccceeeeeeeelllllllllldddddddddddddd") ;
            let paramProvider = this.decode(results.data);
            this.paramsProvider = JSON.parse(paramProvider);
            // this.gVLogger.log("Params from the server : " + this.paramsProvider);
          }
      });

  }

  update(){
    if(this.calledFrom !== "bulkShipment"){
      this.pickPackParamsFormUpdate()
    }else {
      this.updateParamsLocally();
    }
  }

  updateParamsLocally(){
    this.encode();
    pickPackParams.params = this.encoded
    this.nav.pop();
  }

	paramsField(){

	  setTimeout(() => {

      if(this.calledFrom !== "bulkShipment")
        this.pickPackParamsRead();

		this.gVLogger.log("this.customfields" + this.objCustomFormFields);
      this.gVLogger.log("Params from the server : " + this.paramsProvider.documents);
		let paramsCustomFields = this.paramsProvider.documents.find(item=>item.name=="customFields").documentParams.find(Item=>Item.sectionLabel=="none").fields;
		let csvCustomFieldsObjects = this.paramsProvider.params;
		this.objCustomFormFields = [];

		for(let csvField of paramsCustomFields){
      let label = "";
      let value = "";
      let type = "";
			let cutomFieldObj = csvCustomFieldsObjects.find(item=>item.paramId == csvField.paramId);

			type = cutomFieldObj.type;
			if(type === "Empty"){
				cutomFieldObj.value = "";
			}
			this.objCustomFormFields.push(cutomFieldObj);

      if(this.calledFrom === "bulkShipment")
        this.getParamsLocally();

     }

    // alert("cc " + this.calledFrom)

    },800)
	}

  getParamsLocally(){
    console.log("lllllllllllllllllllllllllllllllllllllllllllllllllllllllll" + pickPackParams.params)
    if(pickPackParams.params !== ""){
      try{
        this.objCustomFormFields = JSON.parse(this.decode(pickPackParams.params));
      }
      catch(err){
        // alert(err);
        this.objCustomFormFields = this.objCustomFormFields;
      }
    }

  }

	encode(){
		return this.encoded = btoa(JSON.stringify(this.objCustomFormFields));
	}
	decode(encodeData){
	return	this.deoded=atob(encodeData);
	}

	closeParams(){
		this.pickPackParamsFormUpdate();
		// this.nav.pop();
	}


	pickPackParamsFormUpdate(){
			this.nav.pop();
		this.encode();

		// this.api.post("/shipmentNotice/updatePickPackParams?PickPackParams=" +this.encoded+"&orderId="+this.cart.orderId,"").subscribe(
		// 	result=>{
		// 		if (result.status === 200) {
		// 			this.gVLogger.log("Success message");
		// 			this.msgManager.toastMsg("Values updated successfully!");
		// 			// this.pickPackParamsRead();
    //
		// 		} else {
		// 			this.gVLogger.log("Some error");
		// 			// this.pickPackParamsRead();
		// 		}
		// 	},err => {
		// 		this.gVLogger.log("error while Updating data : " + err);
		// 	})

    for(let ship of this.cart.shipmentsIds){
      this.api.post("/shipmentNotice/updatePickPackParams?PickPackParams=" +this.encoded+"&orderId="+ship,"").subscribe(
        result=>{
          if (result.status === 200) {
            this.gVLogger.log("Success message");
            this.msgManager.toastMsg("Values updated successfully!");
            // this.pickPackParamsRead();

          } else {
            this.gVLogger.log("Some error");
            // this.pickPackParamsRead();
          }
        },err => {
          this.gVLogger.log("error while Updating data : " + err);
        })
    }
	}

	pickPackParamsRead(){

    // alert("this.cart.shipmentId" + this.cart.shipmentId)
		// this.api.post("/shipmentNotice/readPickPackParams?orderId="+this.cart.orderId, "").map(res => res.json()).subscribe(data =>{
		this.api.post("/shipmentNotice/readPickPackParams?orderId="+this.cart.shipmentId, "").map(res => res.json()).subscribe(data =>{
			if((data.status === "200" || data.status === "270") && data.data !== "W10="){
				this.gVLogger.log("if called");
				try{
					this.objCustomFormFields = JSON.parse(this.decode(data.data));
				}
				catch(err){
					// alert(err);
					this.objCustomFormFields = this.objCustomFormFields;
				}
			}
			else{
			}
    });
	}

}



// WEBPACK FOOTER //
// ./src/pages/pickpackparams/pickpackparams.ts